import type { JSX } from 'react'
import type { ITabsContainerProps } from '../TabsContainer'

import { useSSRLazyLoading } from 'utils/hooks'
import { TabsContainer } from '../TabsContainer'
import { TabControlsType } from '../TabsContainer.h'

export interface ITabsInlineControls extends ITabsContainerProps {}

export const TabsInlineControls = ({
  children,
  controlsType = TabControlsType.inRow,
  ...rest
}: ITabsInlineControls): JSX.Element | null => {
  const isShowComponent = useSSRLazyLoading()

  return isShowComponent ? (
    <TabsContainer controlsType={controlsType} {...rest}>
      {children}
    </TabsContainer>
  ) : null
}
